define('ShippingDeliveryLocation.Collection', [
    'Store.Collection',
    'Backbone.CachedCollection',
    'Utils'
], function ShippingDeliveryLocationCollection(
    StoreCollection,
    CachedModel,
    Utils
) {
    'use strict';

    return StoreCollection.extend({
        url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ShippingDeliveryLocation.Service.ss')),
        parse: function parse(results) {
            this.hasShippingAvailable = results.hasShippingAvailable;
            return results.stores;
        }
    });
});
